import getReleaseNotes, {
	ReleaseNotesDownloadParams,
} from '@/lib/getReleaseNotes'
import JsFileDownloader from 'js-file-downloader'
import {
	getSyllabusNameFromCodename,
	trackUniversalResourceEvent,
} from './gtmTracking'

export async function downloadReleaseNotes(
	param: ReleaseNotesDownloadParams,
	abortSignal?: AbortSignal,
	pageUrl?: string,
	pageType?: string,
	syllabusContext?: {
		codename?: string
		isLifeSkills?: boolean
		isMainstream?: boolean
	},
): Promise<[boolean, string]> {
	const { ok, output, message } = await getReleaseNotes(param, abortSignal)

	if (ok && output && output.code === 200) {
		// Track the download event using GTM tracking utility
		try {
			// Get actual file size if API returns 0
			let fileSize = output.size
			if (!fileSize && output.path) {
				const { downloadFileWithSize } = await import(
					'./getFilesizeFormatter'
				)
				fileSize = await downloadFileWithSize(output.path, output.name)
			} else {
				// Use JsFileDownloader as fallback when we have file size from API
				new JsFileDownloader({
					url: output.path,
					filename: output.name,
					autoStart: true,
					forceDesktopMode: true,
				})
			}

			const resourcesToTrack = [
				{
					id: `release-notes-${Date.now()}`,
					name: output.name || 'Release Notes',
					filename: output.name,
					contentType: output.mimeType,
					fileSize,
					url: output.path,
					resourceType: 'release_notes',
					stages: param.stages || [],
					syllabuses: (param.syllabuses || []).map((syllabus) => ({
						taxonomy: syllabus,
						name: getSyllabusNameFromCodename(syllabus),
					})),
				},
			]

			trackUniversalResourceEvent(
				true,
				resourcesToTrack,
				pageType,
				pageUrl,
				undefined,
				syllabusContext,
			)
		} catch (error) {
			console.warn(
				'GTM tracking failed for release notes download:',
				error,
			)
		}

		return [ok, '']
	}
	return [
		false,
		(output?.message || message) ??
			'No resource found. Please adjust the filters to get correct release notes.',
	]
}
